import React from "react";
import * as T from "./types";
import { Shape as ShapeElement } from "react-konva";
import { defineZIndex } from "@utils/zIndexChains";
import { Shape } from "konva/lib/Shape";

const HiddenCanvasElement: React.FC<T.IProps> = React.memo((props) => {

  const shapeRef = React.useRef<Shape>(null);

  React.useEffect(() => {
    defineZIndex(shapeRef, props.id, props.zIndexChain);
  }, [JSON.stringify(props.zIndexChain)]);

  return(
    <ShapeElement
      ref={shapeRef}
      listening={false}
      visible={false}
    />
  )
});

export default HiddenCanvasElement;